<template>
  <div id="app">

    <b-navbar :mobile-burger="false" spaced fixed-top  class="top-nav nav-background">
      <template slot="brand">
        <b-navbar-item class="mainlogo">
          <img src="./assets/logo.png" >
        </b-navbar-item>
      </template>

      <template slot="end" class="">
        <b-navbar-item class="has-text-white has-text-centered-mobile" href="#whatisit">
          מה זה?
        </b-navbar-item>
        <b-navbar-item class="has-text-white has-text-centered-mobile"  href="#howdoyouplay">
          איך משחקים?
        </b-navbar-item>
        <b-navbar-item class="has-text-white has-text-centered-mobile" href="#wheredoyoubuy">
          איפה משיגים?
        </b-navbar-item>
        <b-navbar-item class="has-text-white has-text-centered-mobile" href="#contactus">
          צרו קשר
        </b-navbar-item>
        <b-navbar-item class="has-text-white has-text-centered-mobile" href="#contactus">
          עקבו אחרינו
        </b-navbar-item>


          <b-button tag="a" type="is-text" size="is-medium" class="has-text-white menu-social-link" target="_blank"
                    icon-left="facebook" href="https://www.facebook.com/KombinaBaKnesset">
          </b-button>



        <b-button tag="a" type="is-text" target="_blank"  expanded size="is-medium" class="has-text-white  menu-social-link"
                  icon-left="twitter" href="https://twitter.com/KombinaBKnesset">
        </b-button>

        <b-button tag="a" type="is-text" target="_blank"  expanded size="is-large" class="has-text-white menu-social-link"
                  icon-left="youtube" href="https://www.youtube.com/channel/UCeKSAz2dAqwz594t7bDjApQ">
        </b-button>

       

      </template>

    </b-navbar>

    <section id="main-hero" class="hero introblock ">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-vcentered is-centered">
            <!--
            <div class="column is-12  title has-text-centered-mobile has-text-centered">
              <h1 class="heavy-font has-text-centered-mobile has-text-centered has-text-white">
                <img src="./assets/introtext.png" alt="">
              </h1>

            

            </div>-->

            <div class="column is-5">
              <img src="./assets/hero-shot.png" alt="">
                <a href="#wheredoyoubuy" class=" is-fullwidth button is-centered is-large has-text-centered is-size-3 download-button is-size-3-mobile cta-button buy-button" >
                    השיגו עכשיו!
                </a>
            </div>

            <div class="column is-7">
              <div class="video-container">
              <iframe class="video"  src="https://www.youtube.com/embed/1gfwhoRIpvY?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
              </div>

          </div>
        </div>
        

      </div>
      <!--
      <div class="hero-foot">
        <img src="./assets/cards.png" id="hero-cards">
      </div>
      -->
    </section>

    <section class="gameIntro hero is-fullheight" id="whatisit">
      <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-6">
            <h1 class="is-size-1 title has-text-centered-mobile">מה זה "קומבינה בכנסת"?</h1>
            <p class="is-size-5">משחק קלפים חברתי ומהיר עבור 2-6 שחקנים; קומבינה בכנסת מאפשר לשחקנים להתחרות כמועמדים לראשות הממשלה שמנסים להרכיב ממשלה. השחקן הראשון שמרכיב ממשלה שמקבלת לפחות 61 קולות , בעצמו או בקואליציה עם שחקן אחר, מנצח. </p>
          <p class="is-size-5">בדיוק כמו בפוליטיקה האמיתית, שחקני קומבינה בכנסת יכולים לרמות ולשקר אחד לשני. תוכלו לבלף בהצעת קואליציה או להכריז שיש לכם קלפים שאין לכם. אבל תיזהרו: אם אתם נתפסים, אתם מקבלים עונש ומאבדים קולות.</p>
        <p class="is-size-5">המשחק כולל:</p>
        <div class="content">
            <ul class="content is-size-5">
              <li>36 קלפי ח"כים רגילים</li>
              <li>18 קלפי ח"כים מיוחדים (מאכערים, נוכלים, אופורטוניסטים, וגוזרי קופונים) שיכולים לבצע פעולות מיוחדות</li>
              <li>6 קלפי עזר עם כללי המשחק </li>
              <li>חוברת הוראות</li>
            </ul>
        </div>
          </div>
          
          <div class="column is-6">
            <img src="./assets/game.png" alt="">
          </div>
        </div>
      </div>
      </div>
    </section>

    <section id="howdoyouplay" >
      <div class="container">
        <div class="columns">
          <div class="column is-centered ">
            <h1 class="is-size-1 title has-text-centered">איך משחקים? </h1>
            </div>
        </div>

        <div class="columns instructions is-vcentered">
          <div class="column is-1">
            <p class="bullet is-size-5">1</p>
          </div>
          <div class="column is-6 instructional-step">
            <p class="is-size-5">חלקו מספר קלפים לכל משתתף עפ"י מספר המשתתפים במשחק.</p>

          </div>
          <div class="column is-5">
            <img src="./assets/deal.png" alt="">
          </div>
        </div>

        <div class="columns instructions is-vcentered">
          <div class="column is-1">
            <p class="bullet is-size-5">2</p>
          </div>
          <div class="column is-6 instructional-step">
            <p class="is-size-5">
            כל שחקן בתורו בוחר קלף של המועמד לראשות הממשלה מהקלפים שבידו, ומניח אותו על השולחן.
            </p>
            <p class="is-size-5">
              המועמד לראשות הממשלה הוא החבר הראשון בממשלתך והוא קובע את הגוש הפוליטי אליו שייכת ממשלתך (שמאל קיצוני, שמאל מרכז, ימין מרכז, ימין קיצוני). במשך המשחק הוסף ח"כים לממשלתך על ידי הנחתם מעל מועמדך לראשות הממשלה.
            </p>
          </div>
          <div class="column is-5">
            <img src="./assets/setup.png" alt="">
          </div>
        </div>

        <div class="columns instructions is-vcentered">
          <div class="column is-1">
            <p class="bullet is-size-5">3</p>
          </div>
          <div class="column is-6 instructional-step">
            <p class="is-size-5">
            במהלך תורם, כל שחקן מבצע אחת מהפעולות הבאות:
            </p>
            <div class="content">
            <ul>
              <li class="is-size-5">להציע תיק לח"כ ולהוסיף אותו לממשלתו</li>
              <li class="is-size-5">לזרוק ח"כ ולנהל משא ומתן עם ח"כ חדש</li>
              <li class="is-size-5">לגייס ח"כ נזרק</li>
              <li class="is-size-5">לחבל בממשלת יריב</li>
              <li class="is-size-5">להציע קואליציה לשחקן אחר</li>
              <li class="is-size-5">ליצור שערורייה</li>
            </ul>
            </div>
          </div>
          <div class="column is-5">
            <img src="./assets/options.png" alt="">
          </div>
        </div>

        <div class="columns instructions is-vcentered">
          <div class="column is-1">
            <p class="bullet is-size-5">4</p>
          </div>
          <div class="column is-6 instructional-step">
            <p class="is-size-5">
              המשחק נמשך עד שמורכבת אחת הממשלות הבאות:
</p>

            <div class="content">
              <ul>
                <li class="is-size-5">ממשלה צרה (ממשלה עם 61 קולות לפחות שהורכבה על ידיי שחקן אחד)</li>
                <li class="is-size-5">ממשלת אחדות (ממשלה קואליציונית עם לפחות 61 קולות שהורכבה על ידיי שני שחקנים)</li>
                <li class="is-size-5">ממשלת מיעוט (אם אף שחקן לא הקים ממשלה צרה או ממשלת אחדות כאשר הקופה התרוקנה, השחקן עם הממשלה שזוכה לרוב הקולות מנצח)</li>
              </ul>
            </div>

          </div>
          <div class="column is-5">
            <img src="./assets/winning.png" alt="">
          </div>
        </div>
        
        <div class="columns">
          <div class="column is-centered has-text-centered">

            <a href="KombinaBaKnesset_Rules_2020.pdf" class="button is-centered is-large has-text-centered is-size-1 download-button is-size-6-mobile" target="_blank">
                הורידו את חוקי המשחק
              <img src="./assets/instructions.png" alt="" class="instructions-icon">
            </a>

          </div>
        </div>


        <div class="columns">
          <div class="column is-centered has-text-centered">
        <p class="has-text-centered is-size-3">צפו בהדגמת משחק...</p>
        <div class="video-container-sample">
          <iframe class="video"  src="https://www.youtube.com/embed/AYQgBq-IGXQ" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
          </div>
        </div>
      </div>

    </section>

    <section id="wheredoyoubuy">
      <div class="container ">
        <div class="columns">
          <div class="column is-centered ">
            <h1 class="is-size-1 title has-text-centered has-text-white">איפה משיגים? </h1>
          </div>
        </div>


      <div class="columns">
<!--
          <div class="column is-12">
              <p class="is-size-3 has-text-centered">
                קומבינה בכנסת זמין עכשיו להזמנה מחנויות משחקים נבחרות בארץ:
              </p>



          </div>
          -->


          <div class="column is-6">
          <p class="is-size-5 how-to-get">המשחק זמין כעת להזמנה מ- <a class="has-text-white" href="https://www.thegamecrafter.com/games/kombina-in-the-knesset-%D7%A7%D7%95%D7%9E%D7%91%D7%99%D7%A0%D7%94-%D7%91%D7%9B%D7%A0%D7%A1%D7%AA-">The Game Crafter</a> (חנות משחקים בארצות הברית שמייצרת את המשחקים לפי דרישה).</p>
          <p class="is-size-5 how-to-get">או אתם יכולים להשיג את המשחק בחינם כגרסת Print-and-Play (הדפסה עצמית). תכננו לבלות כשעה עם מדפסת ומספריים.</p>
        </div>
        <div class="column is-6 has-text-centered">

         <iframe style="border:none;background:transparent;margin:0;padding:0;width:100%;height:163px;" src="https://www.tgcwidgets.com/widget.html#id=563C8D9A-818D-11E9-BCB6-3322F5424212&size=full&hidetitle=yes&label=%D7%A7%D7%A0%D7%95%20%D7%A2%D7%9B%D7%A9%D7%99%D7%95&link=Game%20Crafter%20%D7%91%D7%A7%D7%A8%D7%95%20%D7%91%D7%97%D7%A0%D7%95%D7%AA&buttons=two&cl=on&cltext=Game%20Crafter%20%D7%91%D7%A7%D7%A8%D7%95%20%D7%91%D7%97%D7%A0%D7%95%D7%AA&clurl=&clnt=no"></iframe>
          <!--
          <a href="https://www.thegamecrafter.com/cart/sku/5642EAF0-818D-11E9-BCB6-3322F5424212" class="gamecrafterlogo button is-centered is-large has-text-centered is-size-3 download-button" target="_blank">
            הזמינו מ
            <img src="./assets/gamecrafterlogo.png"  alt="">
          </a>

            <form target="_blank" action="https://www.thegamecrafter.com/cart/sku/5642EAF0-818D-11E9-BCB6-3322F5424212" method="POST" style="display: inline;"><input type="submit" class="is-fullwidth gamecrafterlogo button is-centered is-large has-text-centered is-size-3 download-button buy-button" value='קנו עכשיו (61 ₪)'></form>
-->
          <a href="KombinaBaKnesset_PrintAndPlayEdition.pdf" target="_blank" class="is-fullwidth button is-centered is-large has-text-centered is-size-5 download-button">
            הורידו PDF להדפסה עצמית
            <img src="./assets/pnpdownload.png" alt="" class="instructions-icon">
          </a>


        </div>
      </div>

        <!--
          <div class="columns is-mobile is-multiline is-centered">

            <div class="column is-1">
              <figure class="image is-128x128">
                <a href="https://www.mindx.co.il/" target="_blank">
                <img class="is-rounded" src="./assets/mindx.jpg">
                </a>
              </figure>
            </div>

              <div class="column is-1">
                  <figure class="image is-128x128">
                    <a href="https://www.shirion.com/" target="_blank">
                      <img class="is-rounded" src="./assets/shirion.jpg">
                    </a>
                  </figure>
              </div>

            <div class="column is-1">
              <figure class="image is-128x128">
                <a href="https://gameoffun.co.il/product/kombinabaknesset/" target="_blank">

                <img class="is-rounded" src="./assets/mishakeykef.png">
                </a>
              </figure>
            </div>

            <div class="column ">
              <figure class="image is-128x128">
                <a href="https://www.playnjoy.games/" target="_blank">
                <img class="is-rounded" src="./assets/madaeyluach.jpg">
                </a>
              </figure>
            </div>

            <div class="column ">
              <figure class="image is-128x128">
                <a href="https://thekingdom.co.il/" target="_blank">
                <img class="is-rounded" src="./assets/kingdom.jpg">
                </a>
              </figure>
            </div>

          </div>
           -->
        <!--
                <div class="columns is-mobile is-multiline is-centered">
                  <div class="column is-5-tablet is-12-mobile">
                    <a href="https://mindx.co.il/online-store/combine/" class="gamecrafterlogo button is-fullwidth is-centered is-large has-text-centered is-size-3 download-button" target="_blank">
                      <img src="./assets/mindx.jpg"  alt="">
                      הזמינו ממיינדקס
                    </a>

                    <a href="https://gameoffun.co.il/product/kombinabaknesset/" class="gamecrafterlogo button is-fullwidth is-centered is-large has-text-centered is-size-3 download-button" target="_blank">
                      <img src="./assets/mishakeykef.png"  alt="">
                      הזמינו ממשחקי הכיף
                    </a>

                    <a href="https://www.shirion.com/product-page/%D7%A7%D7%95%D7%9E%D7%91%D7%99%D7%A0%D7%94-%D7%91%D7%9B%D7%A0%D7%A1%D7%AA " class="gamecrafterlogo button is-fullwidth is-centered is-large has-text-centered is-size-3 download-button" target="_blank">
                      <img src="./assets/shirion.jpg"  alt="">
                      הזמינו משריון
                    </a>
                  </div>
                </div>


                <div class="columns is-centered">
                  <p class="is-size-4 has-text-centered">
                  <a class="has-text-white" href="https://www.facebook.com/KombinaBaKnesset">הירשמו לדף הפייסבוק שלנו </a> כדי לקבל עדכון כשהמשחק בחנויות.
                  </p>
                </div>
                -->

      </div>
    </section>

    <section id="contactus">
      <div class="container">
        <div class="columns">
          <div class="column is-6 contact-column">
            <form  method="post"
                   @submit.prevent="handleSubmit">
              <input type="hidden" name="form-name" value="ask-question" />
              <div class="container columns has-text-white">
                <div class="column is-12">
                  <h1 class="is-size-1 title has-text-centered">צרו קשר</h1>
                </div>
              </div>
              <div class="container columns has-text-white">
                <div class="column is-12">
                  <input class="input" type="text" name="name" @input="ev => form.name = ev.target.value" placeholder="שם"/>
                </div>
              </div>
              <div class="container columns has-text-white">
                <div class="column is-12">
                  <input class="input" type="text" name="email" @input="ev => form.email = ev.target.value" placeholder="מייל"/>
                </div>
              </div>

              <div class="container columns has-text-white">
                <div class="column is-12">
                  <textarea class="textarea" type="text" name="message" @input="ev => form.message = ev.target.value" placeholder="תוכן הפנייה"/>
                </div>

              </div>

              <div class="container columns ">
                <div class="column is-12 ">
                  <b-checkbox type="is-white" v-model="acceptedPrivacyPolicy">
                    רוצה לקבל עדכונים
                  </b-checkbox>
                </div>

              </div>

              <div class="container columns has-text-white">
                <div class="column is-12 ">
                  <button type="submit" class="button has-text-primary is-family-secondary is-medium has-text-centered">שלח</button>
                </div>
              </div>

            </form>
          </div>
          <div class="column is-6">
            <h1 class="is-size-1 title has-text-centered">עקבו אחרינו</h1>
            <div class="columns is-centered">
              <div class="column is-4">
                <b-button tag="a" expanded size="is-large" class="has-text-primary social-button" target="_blank"
                          icon-left="facebook" href="https://www.facebook.com/KombinaBaKnesset">

                   פייסבוק
                </b-button>
              </div>

              <div class="column is-4">
                <b-button tag="a" target="_blank"  expanded size="is-large" class="has-text-primary social-button"
                          icon-left="twitter" href="https://twitter.com/KombinaBKnesset">
                  טוויטר
                </b-button>

              </div>

              <div class="column is-4">
                <b-button tag="a" target="_blank"  expanded size="is-large" class="has-text-danger social-button"
                          icon-left="youtube" href="https://www.youtube.com/channel/UCeKSAz2dAqwz594t7bDjApQ">
                  יוטיוב
                </b-button>
              </div>
            </div>
            <a class="twitter-timeline my-tweets"  data-lang="he" data-height="300" data-theme="light" href="https://twitter.com/KombinaBKnesset?ref_src=twsrc%5Etfw">Tweets by KombinaBKnesset</a>           </div>
        </div>

      </div>
    </section>

    <b-modal :active.sync="showingContactError" >
      <div class="card is-rounded is-centered">
        <div class="card-content is-rounded is-centered">
          <p class="is-size-4 has-text-centered" v-if="this.form.name=='' || this.form.email==''">אנא הכניסו את השם והמייל שלכם</p>
          <p class="is-size-4 has-text-centered" v-if="!acceptedPrivacyPolicy && this.form.name && this.form.email">You must accept Curiolis' Privacy Policy before sending a message.</p>
          <div class="button is-centered ok-button" @click="showingContactError = false">OK</div>
        </div>

      </div>
    </b-modal>

    <b-modal :active.sync="showingMessageSent" >
      <div class="card is-rounded is-centered">
        <div class="card-content is-rounded is-centered">
          <p class="is-size-4 has-text-centered">תודה שפניתם אלינו! ניצור קשר בקרוב. </p>
          <div class="button is-centered ok-button" @click="showingMessageSent = false">OK</div>
        </div>

      </div>
    </b-modal>

    <div class="section custom-footer">
      <div class="container">

        <div class="container columns has-text-white">
          <div class="column is-1">
            <h2 class="has-text-centered-mobile is-size-4 is-family-secondary is-info has-text-link">
              <img src="./assets/logo.png" alt="">

            </h2>
          </div>
          <div class="column is-10 has-text-centered extra-top-padding">
            <img src="./assets/footer.png" alt="">
            <br>
            <span class="is-size-6 is-centered copyright">   משחקי קוריוליס &copy; {{currentYear}}</span>
          </div>
        </div>


      </div>

    </div>


  </div>
</template>

<script>

  export default {
    data() {
      return {
        form: {
          name: "",
          email: "",
          message:"",

        },
        acceptedPrivacyPolicy: true,
        showingContactError: false,
        showingMessageSent: false,
        showPrivacyPolicy: false,
        showTermsOfUse: false,
        sent: false,
        status: {}

      }
    },

    computed: {
      currentYear: function () {
        let currDate = new Date();
        return currDate.getFullYear()
      },

      numMissingFields: function(){
        let numFields = 0;
        if(this.form.name ===""){
          numFields++;
        }
        if(this.form.email ===""){
          numFields++;
        }
        return numFields;
      }
    },

    methods: {
      encode(data) {
        return Object.keys(data)
                .map(
                        key => `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
                )
                .join("&");
      },
      handleSubmit() {
        if(this.form.name === "" || this.form.email === "" ){
          this.showingContactError = true;
        } else {
          fetch("/", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: this.encode({
              "form-name": "ask-question",
              ...this.form
            })
          })
                  .then(() => {
                    this.showingMessageSent = true;
                    //this.$router.push("thanks");
                  })
                  .catch(() => {

                    //this.$router.push("404");
                  });
        }
      }


    }
  }

</script>

<style lang="scss">
#main-hero{
  background-image: url(./assets/background2.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: -4.5rem;
}

  #hero-cards{
    margin-left:auto;
    margin-right:auto;
    max-height:50vh;
    display:block;
    margin-bottom:0px;
  }

  .gameIntro{
    background-color: #e0e2e6;
  }


.video-container {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;

}

.video-container-sample {
  position: relative;
  width: 70%;
  height: 0;
  padding-bottom: 39.25%;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 4rem;

}

.video {
  border-radius:15px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  box-shadow:
          0 11.5px 32.4px -32px rgba(0, 0, 0, 0.042),
          0 18.4px 44px -32px rgba(0, 0, 0, 0.09),
          0 22.3px 47.7px -32px rgba(0, 0, 0, 0.139),
          0 24.5px 47.4px -32px rgba(0, 0, 0, 0.178),
          0 26.6px 45.5px -32px rgba(0, 0, 0, 0.204),
          0 31.3px 43.7px -32px rgba(0, 0, 0, 0.214),
          0 44.1px 44.4px -32px rgba(0, 0, 0, 0.209),
          0 96px 53px -32px rgba(0, 0, 0, 0.19)
;

}

  .introblock{
    padding-top: 12rem;
    padding-bottom: 9rem;
    border-bottom: 8px solid #0c69a7;
  }

  .top-nav{
    border-top: 2px solid #778eaf;
    border-bottom: 8px solid #0c69a7;
    box-shadow: 0px 10px 40px 0px rgba(0,0,0,0.25);
  }

  section{
    padding-top: 12rem;
    padding-bottom: 12rem;
    border-bottom: 8px solid #0c69a7;

    @media all and (max-width: 768px) {
      padding-top: 1rem;
      padding-bottom: 1rem;
    }
  }

  p {
    margin-bottom: 1rem !important;
  }

  h1{
    color: #0077b9 !important;
  }

  ul{
    margin-left: 2rem;
  }


  .bullet {
    background-color: #0077b9;
    text-align: center;
    border-radius: 100%;
    color: white;
    width: 32px;
    height:32px;
    font-weight: bold;
    @media all and (max-width: 768px) {
      margin-right: auto;
      margin-left: auto;
    }

  }

  .instructional-step{
    margin-right: -3rem;

    @media all and (max-width: 768px) {
      margin-right: 1rem;
      margin-left: 1rem;
    }
  }

.instructions-icon {
  @media all and (max-width: 768px) {
    width: 20%;
  }
}

.how-to-get{
  @media all and (max-width: 768px) {
    margin-right: 1rem;
    margin-left: 1rem;
  }
}

  .instructions {
    border-bottom: 1px solid lightgray;
    padding-top: 2rem;
    padding-bottom:2rem;
  }

  .nav-background{
    background-image: url(./assets/background.png);
    background-size: cover;
    background-position: center;
  }

  .download-button{
    padding-top: 2rem !important;
    padding-bottom: 2rem !important;
    margin-left: 10%;
    margin-right: 10%;
      border-width: 3px !important;
    border-radius: 50px !important;
    /* display: block !important; */
    /* width: 50%; */
    align-self: center;
    justify-self: center;
    font-weight: bold;
    transition: all 200ms ease-in-out;
    color: #0077b9 !important;
      border-color: #0077b9 !important;
      @media all and (max-width: 768px) {
          margin-right: 0rem !important;
          margin-left: 0rem !important;
      }
  }

  .download-button img {
    margin-right: 1rem;
  }

  /deep/ #buy {
    font-size: 3rem;
  }

  .download-button:hover{
    background-color: #0077b9;
      color: white !important;
    border-color: #003e65 !important;
    //border-width: 3px;
    //transform: translateY(-20px);
    /*box-shadow:
            0 11.5px 32.4px -32px rgba(0, 0, 0, 0.042),
            0 18.4px 44px -32px rgba(0, 0, 0, 0.09),
            0 22.3px 47.7px -32px rgba(0, 0, 0, 0.139),
            0 24.5px 47.4px -32px rgba(0, 0, 0, 0.178),
            0 26.6px 45.5px -32px rgba(0, 0, 0, 0.204),
            0 31.3px 43.7px -32px rgba(0, 0, 0, 0.214),
            0 44.1px 44.4px -32px rgba(0, 0, 0, 0.209),
            0 96px 53px -32px rgba(0, 0, 0, 0.19)
  ;*/
  }

  #wheredoyoubuy{
    background-image: url(./assets/background.png);
    background-size: cover;
    background-position: bottom;
    color: white !important;

    .download-button{
      margin-bottom: 3rem;
      //padding: 5rem;
      padding-top: 3rem !important;
      padding-bottom: 3rem !important;
      margin-right: 0px;
      padding-right: 85px;
    }
  }

  .gamecrafterlogo{
      //padding-bottom: 5rem !important;
  }

.gamecrafterlogo img{
  width: 100px;
  height: 100px;
  display: inline-block;
  box-shadow: 0px 10px 26px 0px rgba(0,0,0,0.75);
  border-radius: 5px;
  margin-left: 25px;
  position: absolute;
  right: -20px;
}

  .twitter-timeline {
    border-radius: 5px;
    //border: 1px solid lightgray !important;
  }

  .contact-column{
    border-left: 1px solid lightgray;
  }

  .custom-footer {
    background-image: url(./assets/background.png);
    background-size: cover;
    background-position: center;
    background-color: #355289;
  }

  .social-button {
    font-weight: bold;
  }

.social-button i{
  margin-left: 2rem;
}

  .menu-social-link:hover{
    background-color: rgba(255, 255, 255, 0.9) !important;
    color: #128ece !important;
  }

  .mainlogo {
    pointer-events: none;
  }

    .cta-button{
        margin-right: -1rem;
    }

    .buy-button {
        border-color: green !important;
        color: green !important;
    }

.buy-button:hover {
    background-color: green !important;
    border-color: darkgreen !important;
    color: white !important;
}

</style>
